module.exports = __webpack_public_path__ + "assets/img/8_1451.a0b9b68e.jpg";